import { useSearchParams } from "react-router-dom";

const useSessionId = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("m");
  return sessionId;
};
export default useSessionId;

export const useSurveyUrl = () => {
  const [searchParams] = useSearchParams();
  const surveyUrl = searchParams.get("s");
  return surveyUrl;
};